import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import AuthCallbackView from '../views/AuthCallbackView.vue'
import ForgotPasswordView from '../views/ForgotPasswordView.vue'
import PasswordResetView from '../views/PasswordResetView.vue'
import ListsView from '../views/ListsView.vue'
import ListDetailView from '../views/ListDetailView.vue'
import InvitationsView from '../views/InvitationsView.vue'

const routes = [
  {
    path: '/',
    redirect: '/lists',
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { requiresGuest: true },
  },
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: AuthCallbackView,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordView,
    meta: { requiresGuest: true },
  },
  {
    path: '/auth/password-reset',
    name: 'PasswordReset',
    component: PasswordResetView,
    meta: { requiresGuest: true },
  },
  {
    path: '/lists',
    name: 'Lists',
    component: ListsView,
    meta: { requiresAuth: true },
  },
  {
    path: '/lists/:id',
    name: 'ListDetail',
    component: ListDetailView,
    meta: { requiresAuth: true },
  },
  {
    path: '/invitations',
    name: 'Invitations',
    component: InvitationsView,
    meta: { requiresAuth: true },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Navigation guards
router.beforeEach((to, from, next) => {
  const accessToken = localStorage.getItem('access_token')
  const isAuthenticated = !!accessToken

  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (to.meta.requiresGuest && isAuthenticated) {
    next('/lists')
  } else {
    next()
  }
})

export default router
